import { EmptyStateConfig } from 'modules/customEvents/types';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { pxToRem } from 'utils/convert';
import { CustomEventsEmptyState } from './CustomEventsEmptyState';

const SpinnerWrapper = styled.div`
  border: ${({ theme }) => `${theme.spacing.values.single} solid ${theme.colors.neutrals.grey15}`};
  height: ${pxToRem(300)};
`;

/**
 * Table Body
 * Used to display loading and empty states within table
 */
type CustomEventsTableBodyProps = {
  children: ReactNode;
  emptyStateConfig: EmptyStateConfig;
  isLoading: boolean;
  length: number;
};

export const CustomEventsTableBody = ({
  children,
  emptyStateConfig,
  isLoading,
  length,
}: CustomEventsTableBodyProps) => {
  const { Icon, title, subtitle } = emptyStateConfig;
  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner size={54} />
      </SpinnerWrapper>
    );
  }

  if (length === 0) {
    return <CustomEventsEmptyState Icon={Icon} title={title} subtitle={subtitle} />;
  }

  return <>{children}</>;
};
